export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11656.ae7e54a2.jpg";